export enum ROUTES {
  HOME='/',
  CONTACT='/contact',
  ABOUT='/about',
  SERVICES='/#services',
  ECOMMERCE_SOLUTIONS='/services/ecommerce-solutions',
  WEB_SOLUTIONS='/services/web-solutions',
  MOBILE_APP_SOLUTIONS='/services/mobile-app-solutions',
  TAILORED_SOFTWARE_SOLUTIONS='/services/tailored-solutions',
}
